import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Informe } from './informes.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class InformeService {

  private variosURL: string = urlJoin(environment.apiURL, 'varios')
  private expedientesURL: string = urlJoin(environment.apiURL, 'expedientes')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }


  getInforme(tipoInforme: string, year: string) {
    const params = { tipoInforme, year }; // Construir los parámetros
    const getInformeURL = this.variosURL + "/informes";
    return this.http.get(getInformeURL, { params, responseType: 'blob', observe: 'response' }).pipe(
      tap((response) => {
        this.notificationsService.showSuccessNotification("La descarga comenzará en unos segundos");
      }),
      catchError(error => {
        this.notificationsService.showErrorNotification(error);
        return throwError(() => error);
      })
    );
  }

  getYears(): Observable<any> {
    const getYearsURL = this.expedientesURL + "/years";
    return this.http.get<any>(getYearsURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          return throwError(() => error)
        })
      )
  }

}
